/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { useState } from 'react';
import Typography from '@mui/material/Typography';

import { MetaInfo } from '../../../MetaInfo';
import { DocumentVersionType } from '../../../algorithm/types';
import styles from './InnerMessageFooter.module.scss';
import StyledPopover from './StyledPopover';
interface InnerMessageFooterProps {
  className?: string;
  documentVersion?: DocumentVersionType;
}

export function InnerMessageFooter({ className, documentVersion }: InnerMessageFooterProps) {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const handleDialog = () => {
    setDialogOpen(!dialogOpen);
  };

  if (!documentVersion) return null;

  return (
    <div className={className}>
      <hr />
      <div>
        <MetaInfo
          documentVersion={documentVersion}
          filter={['Endorsed by', 'Published', 'Revised', 'ContentDesignation']}
        />

        <Typography variant="caption" onClick={handleDialog} style={{ cursor: 'pointer' }} className={styles.caption}>
          <span>
            © {new Date().getFullYear()} by Health Endeavors, LLC. All Rights Reserved. Do not Reproduce or
            Redistribute. Click for disclaimer.
          </span>
        </Typography>
        {dialogOpen && <StyledPopover handleDialog={handleDialog} />}
      </div>
    </div>
  );
}
